export const SET_NODES = "SET_NODES";
export const SET_FROM_DATA = "SET_FROM_DATA";

export const setNodes = (nodes) => dispatch => {
  dispatch({
    type: SET_NODES,
    nodes
  });
};

export const setFromData = (from) => dispatch => {
  dispatch({
    type: SET_FROM_DATA,
    from
  });
};




// WEBPACK FOOTER //
// ./src/actions/navbar.js